import {createSelector} from 'reselect';
import props from '../../../props';

export default createSelector(
    props.vip20.level,
    (level) => {
        return {
            level
        }
    }
)